import { render, staticRenderFns } from "./MarketMain.vue?vue&type=template&id=06565b9b&scoped=true"
import script from "./MarketMain.vue?vue&type=script&lang=js"
export * from "./MarketMain.vue?vue&type=script&lang=js"
import style0 from "./MarketMain.vue?vue&type=style&index=0&id=06565b9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06565b9b",
  null
  
)

export default component.exports